import instance, { customConfigFormData } from "../../../Utils/Interceptors/Interceptor";

const ActualizaHallazgoService = async (values) => {
    try {
        return await instance.Backend.post("/Hallazgo/ActualizaHallazgo",values, customConfigFormData);
    } catch (error) {
        console.log(error);
    }
}
export { ActualizaHallazgoService };